module.exports = __webpack_public_path__ + "static/media/arrow-up-black.85cb497f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-up-black.svg
// module id = 147
// module chunks = 0